import React from 'react';
import type { TextProps, ViewProps } from 'react-native';
import { StyleSheet, View } from 'react-native';
import {
  DisplayText,
  MobileHeader,
  theme,
  useBreakpointHelpers,
} from '@sweetgreen/garnish';

export type AccountScreenTitleVisibility = 'ALWAYS' | 'COMPACT';
export type AccountScreenTitleProps = {
  readonly title?: string;
  readonly visibility?: AccountScreenTitleVisibility;
} & ViewProps &
  TextProps;

export const AccountScreenTitle = (
  props: AccountScreenTitleProps,
): React.ReactElement<Text> | null => {
  const { visibility = 'ALWAYS', title } = props;
  const { isMobile } = useBreakpointHelpers();

  if (isMobile) {
    return <MobileHeader title={title} />;
  }

  if (visibility === 'COMPACT') return null;

  return (
    <View style={styles.row}>
      <DisplayText style={styles.regularWidthTitle} size={3}>
        {title}
      </DisplayText>
    </View>
  );
};

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  regularWidthTitle: {
    marginBottom: theme.spacing.medium,
  },
});
